import React, { useState, useEffect, useContext } from 'react'
import { ErrorBelowInputField } from './elements/Errors'
import { InputText } from './elements/Inputs'
import SubmitButton, { ButtonFontSize } from './elements/SubmitButton'
import TrackingResultsModal from '../home/TrackingResultsModal'
import { TrackingFormContext } from '../context/TrackingFormContext'
import { useRouter } from 'next/router'
import { event } from '@/utils/gtag'
import { useSession } from 'next-auth/react'
import ErrorModal from '../portal/ui/modals/ErrorModal'

const TrackingForm: React.FunctionComponent = () => {
  const [tracking, setTracking] = useState('')
  const [loading, setLoading] = useState(false)
  const [serializedFormData, setSerializedFormData] = useState('')
  const [notFound, setNotFound] = useState(false)
  const { trackingFormApiResponse, setTrackingFormApiResponse } =
    useContext(TrackingFormContext)
  const [isTrackingModalOpen, setIsTrackingModalOpen] = useState<boolean>(false)
  const router = useRouter()
  const { data: session, status } = useSession()

  useEffect(() => {
    setTracking('')
  }, [])

  useEffect(() => {
    if (router.query.trackingError === 'not_found') {
      setNotFound(true)
      router.replace('/', undefined, { shallow: true })
    }
  }, [router.query.trackingError])

  const submitForm = async () => {
    setLoading(true)

    try {
      if (process.env.SENTRY_ENV === 'production')
        event({
          action: 'Tracking Form Submitted',
          category: 'Tracking',
          label: 'Tracking Form',
          value: status,
        })
      router.push({
        pathname: `/portal/account/shipments`,
        query: { query: tracking },
      })
    } catch (error: any) {
      setLoading(false)
      setTrackingFormApiResponse({
        errors: 'Y',
        bolermsg:
          'Unable to track shipment at this time. Please try again later.',
      })
    }
  }
  const handleCloseErrorModal = () => {
    setNotFound(false)
    setLoading(false)
  }

  return (
    <section>
      <form
        onSubmit={(event) => {
          event.preventDefault()
          submitForm()
        }}
      >
        <div className="items-end mt-3 md:mt-6 md:flex md:space-x-4">
          <div className="flex-1">
            <InputText
              labelText="Search by Freight Bill, Interline, or Shipper Number"
              type="text"
              placeholder="Add number"
              value={tracking}
              characterMax={15}
              onChange={(event: any) => {
                setTrackingFormApiResponse({})
                setTracking(event.target.value)
              }}
            />
          </div>
        </div>

        {trackingFormApiResponse.errors === 'Y' && (
          <ErrorBelowInputField
            errorMessage={trackingFormApiResponse.bolermsg}
          />
        )}

        <div className="mt-3 md:mt-6">
          <p className="mb-3 text-sm md:mb-5 md:text-nptBase">
            <a
              href="/login"
              className="underline text-blue hover:no-underline"
              target="_blank"
              rel="noreferrer"
            >
              Sign in
            </a>{' '}
            to your customer account in order to view your Images, Documents,
            and Account Details.
          </p>
          <p className="mb-3 text-sm md:mb-5 md:text-nptBase">
            Or&nbsp;
            <a
              href="/register"
              className="underline text-blue hover:no-underline"
              target="_blank"
              rel="noreferrer"
            >
              create an account
            </a>{' '}
            and you will be up running in no time.
          </p>
        </div>

        <SubmitButton
          text={loading ? 'Loading...' : 'Track Shipment'}
          fontSize={ButtonFontSize.small}
          isDisabled={tracking ? (loading ? true : false) : true}
        />
      </form>

      {trackingFormApiResponse.errors === 'N' && isTrackingModalOpen && (
        <TrackingResultsModal
          isTrackingModalOpen={isTrackingModalOpen}
          setIsTrackingModalOpen={setIsTrackingModalOpen}
          apiResponse={trackingFormApiResponse}
          serializedFormData={serializedFormData}
        />
      )}
      {notFound && (
        <ErrorModal
          copy="Please check the number that you entered and try again."
          cta="Okay"
          heading="We cannot find that shipment"
          onClose={handleCloseErrorModal}
          allowClickOutside
        />
      )}
    </section>
  )
}

export default TrackingForm
